import React from 'react';
import Link from 'next/link';
import { Button, Flex, Box } from '@chakra-ui/react';
import { paths } from 'constants/paths';

export const ContactSection: React.FC = () => (
  <Box position="relative" marginTop="72px" height="306px">
    <Flex
      justify="center"
      position="absolute"
      width="100vw"
      maxWidth="100vw"
      overflowX="hidden"
      top={0}
      left="50%"
      transform="translateX(-50%)"
    >
      <Box
        width={3000}
        height={{
          base: '306px',
          xs: '375px',
        }}
        textAlign="center"
        padding="72px 24px"
        bg="brand.gradient"
      >
        <Box>
          <Box marginBottom="32px" textStyle="body1" color="textGray.87">
            最後までご覧いただきありがとうございます。
            <br />
            あなたもshizaiでパッケージを作りませんか？
            <Box display={{ base: 'block', md: 'none' }} />
            どんなことでもお気軽にご相談ください。
          </Box>
          <Link href={paths.contact} passHref>
            <Button width={{ base: '100%', md: 'auto' }} p={{ base: '21px 0', md: '28px 0' }}>
              相談してみる
            </Button>
          </Link>
        </Box>
      </Box>
    </Flex>
  </Box>
);
